import React from 'react'
import Head from 'next/head'
import dynamic from 'next/dynamic'

const Footer = dynamic(() => import('@/components/home/footer'))
const KPHead = dynamic(() => import('@/components/head'))
const TopNavigation = dynamic(() => import('@/components/top-navigation'))

import { createResource, useResource } from '@/lib/i18n'
import styled from 'styled-components'
import { Animation, Reveal } from 'react-genie'

const resource = createResource({
  en: {
    contentTitle: 'Kredit Pintar Attention',
    description:
      'All impacts arising from lending and borrowing activities with Kredit Pintar, are borne by each party.',
    sections1:
      "The Information Technology-based Peer to Peer Lending Service ('Fintech Loan') is a civil agreement between Lender and Borrower, so that all risks arising from the agreement are borne entirely by each party.",
    sections2:
      'Every Lender is fully responsible for all credit risks of late or default payments arising from Fintech Loan. No national entity or authority is responsible for any such risks or provides compensation for the losses or other consequences arising with regards to that matter in any form.',
    sections3:
      "The Platform with the approval of the respective Users (Lenders and/or Borrowers) accesses, acquires, stores, administers and/or uses the Users’ personal data of Users ('Data Utilization') on or inside objects, electronic devices (including smartphones or phones cellular), hardware, software, electronic documents, applications or electronic systems owned by the Users or controlled by the Users, by notifying the purpose, limitations and mechanisms of the Data Utilization to the Users concerned before obtaining such consent.",
    sections4:
      'Lenders who do not have sufficient information and experience on the Information Technology-based Money Lending Services or Fintech Loan are advised not to use this service.',
    sections5:
      'Borrowers should carefully consider the loan interest rate along with other costs in accordance with the ability to pay off the loan prior to using the Fintech Loan facility. ',
    sections6:
      'Every fraudulent activity arising in Fintech Loan will be recorded digitally in cyberspace and may potentially be informed to the public through social media networks.',
    sections7: 'Every user should read and understand this information before deciding to become a Lender or Borrower.',
    sections8:
      "The Government, in this matter the Financial Services Authority, shall not be liable for any breach or non-compliance by the User, either the Lender or the Borrower (either by User's intent or negligence) towards the provisions of the laws and regulations or agreements or agreements between the Platform and the Lender and/or Borrower.",
    sections9:
      'Every transaction and lending activity or the implementation of the agreements on lending activity between or involving the Platform, Lender and/or Borrower shall be made through escrow and virtual accounts as required based on the Regulation of the Financial Services Authority Number 77 / POJK.01 / 2016 on The Information Technology-based Money Lending Services and the violation or non-compliance towards those provisions constitute evidence of a violation of law by the Platform so that the Platform shall bear the indemnity suffered by each User as a direct result of the above breach of the law without prejudice to the right of the User suffering loss according to the Civil Law.',
  },
  id: {
    contentTitle: 'Kredit Pintar Perhatian',
    description:
      'Segala dampak yang timbul dari kegiatan pinjam meminjam dengan Kredit Pintar, ditanggung oleh msaing-masing pihak.',
    sections1:
      'Layanan Pinjam Meminjam Berbasis Teknologi Informasi merupakan kesepakatan perdata antara Pemberi Pinjaman dengan Penerima Pinjaman, sehingga segala risiko yang timbul dari kesepakatan tersebut ditanggung sepenuhnya oleh masing-masing pihak.',
    sections2:
      'Resiko Kredit atau Gagal Bayar dan seluruh kerugian dari atau terkait dengan kesepakatan pinjam meminjam ditanggung sepenuhnya oleh Pemberi Pinjaman. Tidak ada lembaga atau otoritas negara yang bertanggung jawab atas resiko gagal bayar dan kerugian tersebut.',
    sections3:
      'Penyelenggara dengan persetujuan dari masing-masing Pengguna (Pemberi Pinjaman dan/atau Penerima Pinjaman) mengakses, memperoleh, menyimpan, mengelola dan/atau menggunakan data pribadi Pengguna (‘Pemanfaatan Data’) pada atau di dalam benda, perangkat elektronik (termasuk smartphone atau telepon seluler), perangkat keras (hardware) maupun lunak (software), dokumen elektronik, aplikasi atau sistem elektronik milik Pengguna atau yang dikuasai Pengguna, dengan memberitahukan tujuan, batasan dan mekanisme Pemanfaatan Data tersebut kepada Pengguna yang bersangkutan sebelum memperoleh persetujuan yang dimaksud.',
    sections4:
      'Pemberi Pinjaman yang belum memiliki pengetahuan dan pengalaman pinjam meminjam, disarankan untuk tidak menggunakan layanan ini.',
    sections5:
      'Penerima Pinjaman harus mempertimbangkan tingkat bunga pinjaman dan biaya lainnya sesuai dengan kemampuan dalam melunasi pinjaman.',
    sections6:
      'Setiap kecurangan tercatat secara digital di dunia maya dan dapat diketahui masyarakat luas di media sosial.',
    sections7:
      'Pengguna harus membaca dan memahami informasi ini sebelum membuat keputusan menjadi Pemberi Pinjaman atau Penerima Pinjaman',
    sections8:
      'Pemerintah yaitu dalam hal ini Otoritas Jasa Keuangan,tidak bertanggung jawab atas setiap pelanggaran atau ketidakpatuhan oleh Pengguna,baik Pemberi Pinjaman maupun Penerima Pinjaman(baik karena kesengajaan atau kelalaian Pengguna)terhadap ketentuan peraturan perundang-undangan maupun kesepakatan atau perikatan antara Penyelenggara dengan Pemberi Pinjaman dan/atau Penerima Pinjaman.',
    sections9:
      'Setiap transaksi dan kegiatan pinjam meminjam atau pelaksanaan kesepakatan mengenai pinjam meminjam antara atau yang melibatkan Penyelenggara,Pemberi Pinjaman dan/atau Penerima Pinjaman wajib dilakukan melalui escrow account dan virtual account sebagai mana yang diwajibkan berdasarkan Peraturan Otoritas Jasa Keuangan Nomor77/POJK.01/2016 tentang Layanan Pinjam Meminjam Uang Berbasis Teknologi Informasi dan pelanggaran atau ketidakpatuhan terhadap ketentuan tersebut merupakan bukti telah terjadinya pelanggaran hukum oleh Penyelenggara sehingga Penyelenggara wajib menanggung ganti rugi yang diderita oleh masing-masing Pengguna sebagai akibat langsung dari pelanggaran hukum tersebut diatas tanpa mengurangi hak Pengguna yang menderita kerugian menurut Kitab Undang-Undang Hukum Perdata.',
  },
})

const Attention = () => {
  const { t } = useResource(resource)
  return (
    <AttentionStyle>
      <Reveal animation={Animation.FadeIn}>
        <KPHead metaTitle="attention" />
        <Head>
          <meta name="description" content={t('description')} />
        </Head>
        <TopNavigation />
        <div className="attention">
          <h1 className="title">{t('contentTitle')}</h1>
          <div className="content">
            <div>
              <div>
                <span>1. </span>
                {t('sections1')}
              </div>
              <div>
                <span>2. </span>
                {t('sections2')}
              </div>
              <div>
                <span>3. </span>
                {t('sections3')}
              </div>
              <div>
                <span>4. </span>
                {t('sections4')}
              </div>
              <div>
                <span>5. </span>
                {t('sections5')}
              </div>
              <div>
                <span>6. </span>
                {t('sections6')}
              </div>
              <div>
                <span>7. </span>
                {t('sections7')}
              </div>
              <div>
                <span>8. </span>
                {t('sections8')}
              </div>
              <div>
                <span>9. </span>
                {t('sections9')}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </Reveal>
    </AttentionStyle>
  )
}

export default Attention

const AttentionStyle = styled.div`
  width: 100%;
  min-height: 30vh;
  @media only screen and (max-width: 1000px) {
    .attention {
      margin: 0 auto;
      padding: 78px 24px 16px;
      .title {
        margin: 32px 0 24px;
        text-align: center;
        font-size: 24px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 28px;
      }
      .content {
        font-size: 16px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #757575;
        line-height: 24px;
        div {
          padding-bottom: 12px;
          span {
            color: #212121;
            font-family: Roboto-Bold, Roboto;
          }
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    .attention {
      max-width: 1140px;
      margin: 0 auto;
      padding: 82px 0;
      border-bottom: 1px solid #eee;
      .title {
        margin: 80px 0 48px;
        text-align: center;
        font-size: 36px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 48px;
      }
      .content {
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #757575;
        line-height: 24px;
        div {
          padding-bottom: 20px;
          span {
            color: #212121;
            font-family: Roboto-Bold, Roboto;
          }
        }
      }
    }
  }
`
